import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as api from "../../api";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { RouteComponentProps } from "react-router-dom";
import {
  detectMobile,
  formatContent,
  formatDateWithFromCalendar,
  isNullOrUndefined, retrievePriority
} from "../../utils/formatting";
import { WorksOrder } from "../../models/WorksOrders";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import LoadingSpinner from "../../storybook/LoadingSpinner";
import { trackEvent } from "../../appInsights/TelemetryService";
import { useDispatch, useSelector } from "react-redux";
import {
  getContractorName,
  getIntegeratedContractor,
  selectedTenacyType,
  workOrderRepairObject,
} from "../../ducks/redux/actions/getAddress";
import { RepairStatusField, RepairStatusText } from "../../models/Repair/Repair";
import { SurveyTypes } from "../../models/shared/Enum";
import woImg from '../../assets/icons/Work-order-type-Survey.png';
import '../../utils/commonCss/icons.css';
import { cancelRepairReferenceReasons, woChronologyTabState, woFailureCase, resumeDraftRepair, userResumeDraftDataCache, loadDuplicateRepairPage } from "../../ducks/redux/actions/userChoices";
import { priorityCode } from "../../ducks/redux/actions/dashboardReducer.actions";
import RepairDiagnosticsDetailsCard from "../RepairDiagnosticsDetailsCard";
import RepairDiagnosticsSessionDetails from "../../models/Diagnostics/RepairDiagnosticsSessionDetails";
import ErrorComponent from "../APIErrorComponent/ErrorComponent";
import { getRepairHistories, getWorkOrderByIdAPI, getWorkOrderEntity } from "../APIErrorComponent/APIConstantName";
import { catalystTriageContractorType, EMAContractorType } from "../../models/Repair/Contractor";
import Button from "../../Button/Button";
import { hasAR1Role } from "../../utils/GetRoles/permission";
interface WorkOrderDetailsProps extends RouteComponentProps<any> {
  id: string; status: string;
}
const WorkOrderDetailsComponent: React.FC<WorkOrderDetailsProps> = (props) => {
  const { t } = useTranslation();
  const isMobile = detectMobile();
  const workOrderItem: WorksOrder = {};
  const [isLoading, setIsLoading] = useState(true);
  const [workorder, setWorkOrderData] = useState(workOrderItem);
  const [contractorName, setContractorName] = useState("");
  const [contractorEmail, setContractorEmail] = useState("");
  const [contractorPhone, setContractorPhone] = useState("");
  const [isEmaContractor, setIsEmaContractor] = useState(false);
  const [emaNumbers, setEmaNumbers] = useState<string[]>([]);
  const [emaEmails, setEmaEmails] = useState<string[]>([]);
  const [statusChangeDate, setStatusChangeDate] = useState("");
  const [isActiveDescription, setIsActiveDescription] = useState(false);
  const [activeWorkOrder, setActiveWorkOrder] = React.useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [dropDown, setDropDown] = useState("none");
  const [workOrderType, setWorkOrderType] = useState("");
  const dispatch = useDispatch();
  const [diagnosticsDetails, setDiagnosticsDetails] = useState<RepairDiagnosticsSessionDetails | null>(null);
  const [EmaUnknownContactTriage, setEmaUnknownContactTriage] = useState(false);


  const navigateToMediaChronology = () => {
    dispatch(woChronologyTabState("Media"));
    props.history.push("/WorkOrderChronology");
  };
  const getPermissionsData = useSelector(
    (state: any) => state?.userChoicesReducer?.userProfilePermissions
  );
  const workOrderData = useSelector(
    (state: any) => state?.userChoicesReducer?.workOrderData
  );
  const assetValue = useSelector(
    (state: any) => state?.userChoicesReducer?.assetValue
  );
  const isActiveTenancy = useSelector(
    (state: any) => state?.userChoicesReducer?.isActiveTenancy
  );

  const cancellationData = useSelector(
    (state: any) => state?.userChoicesReducer?.cancellationReasonsRefJson
  );

  const isP360Maintainence = useSelector(
    (state: any) => state.userChoicesReducer?.isP360RepairsMaintainenceValue
  );

  const currentAssetEligibilityDetails = useSelector(
    (state: any) => state?.addresses?.currentAssetEligibilityDetails
  );

  const GetCancellationData = async () => {
    if (cancellationData && Object.keys(cancellationData).length > 0) {
      return;
    }
    const resp = await api.getReferenceDataRepair("repair-cancellation-reasons");
    const cancellationreasons = ((resp?.[0]?.namespace?.keyValues ??
      {}) as unknown) as Record<string, any>;
    dispatch(cancelRepairReferenceReasons(cancellationreasons));
  };

function getCreatedBy(workorder: any) {
  if (
    workorder.job?.createdBy
  ) {
    return workorder.job?.createdBy;
  }
  else if(workorder.externalSource === RepairChannel.TotalConnect && workorder.createdBy){
    return workorder.createdBy;
  }
  else if (workorder.channel === RepairChannel.ColleagueSelfServe) {
    return workorder.job?.createdBy;
  }
  return workorder.channel;
}


  useEffect(() => {
    GetCancellationData();
    const fetchDiagnostics = async () => {
      if (
        workOrderData?.statuses?.isEnhancedDiagnosticsRepair &&
        workOrderData?.identifiers.repairDiagnosticsSessionIdentifier
      ) {
        try {
          const data = await api.getRepairDiagnosticFinalStatus(workOrderData?.identifiers.repairDiagnosticsSessionIdentifier);
          setDiagnosticsDetails(data);
        } catch (e) {
          setDiagnosticsDetails(null);
        }
      }
    };
    fetchDiagnostics();
  }, [workOrderData, cancellationData]);


  useEffect(() => {
    trackEvent("WorkOrderDetails");
    getWorkOrder(props.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActiveTenancy, workOrderData]);


  const dropDownFunction = () => {
    if (dropDown === "none") setDropDown("block");
    else setDropDown("none");
  };
  const callPageHandler = () => {
    if (!isP360Maintainence) {
      dispatch(workOrderRepairObject(null));
      dispatch(resumeDraftRepair(false));
      dispatch(userResumeDraftDataCache(null));
      dispatch(loadDuplicateRepairPage(false));
      dispatch(selectedTenacyType(workOrderData?.asset?.type?.assetTypeName));
      dispatch(priorityCode(''));
      dispatch(woFailureCase());
      props.history.push("/RepairAsset", { previousPathname: window.location.pathname });
    };
  }
  const completeAssessment = () => {
    props.history.push('/VulnerabilityAssessment');
  }


  // Helper: Handle contractor data
  const handleContractorData = async (workOrderData: any) => {
    if (isNullOrUndefined(workOrderData.identifiers.contractorSiteIdentifier)) return;
    const contractorsData = await api.getContractors(workOrderData.identifiers.contractorSiteIdentifier);
    const isUnknownEmaTriage = [
      EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE,
      EMAContractorType.UNKNOWN_EMA_TRIAGE,
      catalystTriageContractorType.CATALYST_TRIAGE_EMA
    ].includes(workOrderData.identifiers.contractorSiteIdentifier);
    setEmaUnknownContactTriage(isUnknownEmaTriage);
    const isEma = contractorsData?.[0]?.statuses?.isEMA === true && !isUnknownEmaTriage;
    setIsEmaContractor(isEma);
    if (contractorsData?.length > 0) {
      const emailAddresses = contractorsData?.[0]?.contacts?.[0]?.addresses?.digitalAddresses?.[0]?.emailAddresses ?? [];
      const telecomsAddresses = contractorsData?.[0]?.contacts?.[0]?.addresses?.digitalAddresses?.[0]?.telecomsAddresses ?? [];
      const emaEmailValues = (emailAddresses as any[]).map((x) => x?.value).filter(Boolean);
      const emaNumberValues = (telecomsAddresses as any[]).map((x) => x?.number).filter(Boolean).map((num: string) => num.replaceAll(/\s+/g, ""));
      setEmaEmails(isEma ? emaEmailValues : []);
      setEmaNumbers(isEma ? emaNumberValues : []);
      setContractorEmail(emailAddresses?.[0]?.value ?? "");
      const phone = telecomsAddresses?.[0]?.number;
      setContractorPhone(phone ?? "");
      dispatch(getIntegeratedContractor(contractorsData?.[0]?.statuses.isIntegrated));
      dispatch(getContractorName(contractorsData?.[0]?.name));
      setContractorName(contractorsData?.[0]?.name);
    } else {
      setIsEmaContractor(false);
      setEmaEmails([]);
      setEmaNumbers([]);
    }
  };

  // Helper: Handle repair histories
  const handleRepairHistories = async (workOrderData: any) => {
    const repairHistories: any = await api.getRepairHistories(workOrderData.identifiers.worksOrderIdentifier);
    if (repairHistories?.length > 0) {
      const sortedResults = repairHistories.sort((a: any, b: any) => new Date(b.createDateTime).valueOf() - new Date(a.createDateTime).valueOf()).slice(0, 3);
      if (sortedResults?.length > 0) {
        setStatusChangeDate(sortedResults?.[0]?.createDateTime);
      }
    }
  };

  // Helper: Set work order type
  const setWorkOrderTypeByStatus = (status: string) => {
    if (status === RepairStatusField.CatalystTier2Triage) setWorkOrderType(RepairStatusField.Tier2);
    else if (status === RepairStatusField.CatalystEMATriage) setWorkOrderType(RepairStatusField.EMAtriage);
    else if (status === RepairStatusField.CatalystDefectTriage) setWorkOrderType(RepairStatusField.Defecttriage);
  };

  // Main function
  const getWorkOrder = (id: string) => {
    (async () => {
      try {
        if (!workOrderData) return;
        if (workOrderData.identifiers) {
          await handleContractorData(workOrderData);
          await handleRepairHistories(workOrderData);
        }
        if (workOrderData.job.description === "Inspect Damp and Mould" || workOrderData.job.repairReason === "Inspect Damp and Mould") {
          workOrderData.job.description = "Investigate damp or mould";
        }
        setWorkOrderData(workOrderData);
        setIsLoading(false);
        setWorkOrderTypeByStatus(workOrderData?.statuses?.status);
      } catch (e) {
        setIsLoading(false);
        console.error(e);
      }
    })();
  };

  const viewWorkOrderDescriptionHandler = (id: string, description: string) => {
    if (activeWorkOrder !== "" && activeWorkOrder.indexOf(id) >= 0) {
      setActiveWorkOrder("");
      setAdditionalInfo("");
      setIsActiveDescription(false);
    } else {
      setActiveWorkOrder(id);
      if (workorder.job?.repairType === SurveyTypes.survey) {
        setAdditionalInfo(workorder.job?.additionalInformation || "");
      } else {
        if (workorder.channel !== RepairChannel.CustomerSelfService &&
          workorder.channel !== RepairChannel.ERGO &&
          workorder.channel !== RepairChannel.ColleagueSelfServe) {
          // Description is not always concatenated
          setAdditionalInfo(workorder.job?.description ?? "-");
        } else if (isNullOrUndefined(workorder.job?.repairReason) && isNullOrUndefined(workorder.job?.additionalInformation)) {
          // Description is not always concatenated
          setAdditionalInfo('-');
        } else {
          // Description is not always concatenated
          setAdditionalInfo(workorder.job?.repairReason == null
            ? [workorder.job?.description, workorder.job?.additionalInformation].filter(Boolean).join('. ')
            : [workorder.job?.repairReason, workorder.job?.additionalInformation].filter(Boolean).join('. '));
        }
      }
      setIsActiveDescription(true);
    }
  };

  const viewActiveToggle = useCallback(
    (id: any) => {
      if (activeWorkOrder === id) {
        return (
          <div
            id={"WorkOrderAdditionalInfo-active" + id}
            data-testid="WorkOrderAdditionalInfo-active-multiply"
            className="plus-sign mt-10"
          >
            {"⨯"}
          </div>
        );
      } else {
        return (
          <div
            id={"WorkOrderAdditionalInfo-active" + id}
            data-testid="WorkOrderAdditionalInfo-active-plus"
            className="plus-sign mt-10"
          >
            {"+"}
          </div>
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeWorkOrder, isActiveDescription]
  );

  const viewWorkOrderDetail = useCallback(
    (description: string) => {
      if (description !== undefined && description !== "") {
        return (
          <div
            className="accordion-content w-full global-txt"
            id="WorkOrderAdditionalInfo-accor2"
          >
            <div
              className=""
              id="WorkOrderAdditionalInfo-con"
            >
              <div
                className="grid global-txt"
                id="WorkOrderAdditionalInfo-div1"
              >
                <div
                  className="box pl-6 ml-6 "
                  id="WorkOrderAdditionalInfo-div2"
                >
                  <div
                    className="flex flex-row flex-col bg-grey"
                    id="WorkOrderAdditionalInfo-div3"
                  >
                    <div
                      className="pr-12 mt-2 mb-2 ml-4 wd-100 div-word-break"
                      id="WorkOrderAdditionalInfo-div4"
                    >
                      <div>{description}</div>
                    </div>
                  </div>

                  <div
                    className="flex flex-row flex-col bg-grey"
                    id="WorkOrderAdditionalInfo-div5"
                  >
                    <div
                      className="pr-12 mt-2 mb-2 ml-4 wd-100 div-word-break"
                      id="WorkOrderAdditionalInfo-div6"
                    >
                      <div>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        {workOrderData?.identifiers?.documents?.documentIdentifiers?.length > 0 && workOrderData?.channel !== RepairChannel.Automated && (<a
                          href=""
                          data-testId="ViewWODetailsMedia"
                          className="text-teal underline hover:underline"
                          onClick={navigateToMediaChronology}
                        >
                          <b> {t("View media")}</b>
                        </a>
                        )}
                      </div>
                    </div>
                  </div>

                  {props.status === RepairStatusField.CatalystTier2Triage || props.status === RepairStatusField.CatalystEMAStatus ||
                    props.status === RepairStatusField.CatalystDefectTriage ? (

                    <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
                      <div className="px-2 pr-8">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="text-purple-100 w-6 h-6">
                          <path d="M480 179.6C498.6 188.4 512 212.1 512 240C512 267.9 498.6 291.6 480 300.4V448C480 460.9 472.2 472.6 460.2 477.6C448.3 482.5 434.5 479.8 425.4 470.6L381.7 426.1C333.7 378.1 268.6 352 200.7 352H192V480C192 497.7 177.7 512 160 512H96C78.33 512 64 497.7 64 480V352C28.65 352 0 323.3 0 288V192C0 156.7 28.65 128 64 128H200.7C268.6 128 333.7 101 381.7 53.02L425.4 9.373C434.5 .2215 448.3-2.516 460.2 2.437C472.2 7.39 480 19.06 480 32V179.6zM200.7 192H192V288H200.7C280.5 288 357.2 317.8 416 371.3V108.7C357.2 162.2 280.5 192 200.7 192V192z"></path></svg>
                      </div>
                      <div className="flex items-center">
                        <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                          {props.status === RepairStatusField.CatalystTier2Triage ? t("CatalystTIER2WOMsg") :
                            props.status === RepairStatusField.CatalystEMAStatus ? t("CatalystEMAWOMsg") :
                              props.status === RepairStatusField.CatalystDefectTriage ? t("CatalystDEFECTWOMsg") : null}

                        </p>
                      </div>
                    </div>
                  ) :
                    (null)
                  }

                </div>
              </div>
            </div>
          </div>
        );
      }
    },
    [additionalInfo]
  );

  const getContactNumber = () => {
    if (isNullOrUndefined(workOrderData?.reporter?.reporterRelationship)) {
      return workOrderData?.reporter?.addresses?.telecomsAddresses?.[0]?.number || "-"
    } else {
      return `${workOrderData?.reporter?.addresses?.telecomsAddresses?.[0]?.number}, ${workOrderData?.reporter?.reporterRelationship?.reportedBy}, ${workOrderData?.reporter?.person?.name?.givenName}`
    }
  }
  const showCancellationInfo = () => {
    return workorder?.statuses?.status === RepairStatusText.Cancelled && workorder?.statuses?.metaData?.some(
      (meta) => meta.key === "ReasonCode"
    );
  }
  const getCancelledBy = () => {
    if (workorder?.statuses?.channel === RepairChannel.CustomerSelfService)
      return t("customer");
    else if (workorder?.statuses?.channel === RepairChannel.Northgate)
      return t("Northgate");
    else
      return workorder?.statuses?.user?.name;
  }
  const getCancelledReason = () => {
    const cancelledReason = workorder?.statuses?.metaData?.find(
      (meta) => meta.key === "ReasonCode"
    )?.value as string;
    if (cancelledReason) {
      const cancelReasonsList = Object.values(cancellationData ?? {}) as Array<{ optionCode?: string; optionValue?: string }>;
      const reasonObj = cancelReasonsList.find((reason) => reason?.optionCode === cancelledReason);
      return reasonObj?.optionValue ?? cancelledReason;
    }
  }


  const getContractorDisplayName = () => {
    if (EmaUnknownContactTriage) {
      return t('managing_agent');
    }
    if (contractorName && contractorName !== "") {
      return contractorName === "Peabody Surveying Team"
        ? t('peabody_surveyor')
        : contractorName;
    }
    return "-";
  };
  const isUnknownTrade =
    workorder.job?.trade === "Unknown" &&
    workorder.channel !== RepairChannel.CustomerSelfService &&
    workorder.channel !== RepairChannel.ERGO &&
    workorder.channel !== RepairChannel.ColleagueSelfServe;

  const isSelfServiceChannel =
    workorder.channel === RepairChannel.CustomerSelfService ||
    workorder.channel === RepairChannel.ERGO ||
    workorder.channel === RepairChannel.ColleagueSelfServe ||
    workorder.channel === RepairChannel.Automated;

  let descriptionText;

  if (isUnknownTrade) {
    descriptionText = t("RepairDescription_ErrorMessage");
  } else if (isSelfServiceChannel) {
    if (workorder.statuses?.isRecall && workorder.identifiers?.jobNumber) {
      descriptionText =
        formatContent(workorder.job?.description?.split(".")[0]) +
        " . " +
        formatContent(workorder.job?.description?.split(".")[1]);
    } else {
      descriptionText = formatContent(workorder.job?.description?.split(".")[0]);
    }
  } else {
    descriptionText = formatContent(workorder.job?.trade);
  }

  const StatusShow = (workorder: any) => {
    if (workorder.statuses?.isPendingAssessment && workorder?.assessmentInformation && workorder?.job?.sorCode === t("PRODAMP")) {
      return t("Pending_Assessment")
    }
    else if (workorder?.statuses?.status === "In Diagnosis" && workorder.statuses.isRaisedAsTriage) {
      return t("Under_review")
    }
    else if (workorder?.statuses?.status === "In Diagnosis") {
      return t("draft")
    }
    else if ((workorder.statuses?.status === "Unappointed" || workorder.statuses?.status === "Reported to EMA") && workorder.job?.repairType === SurveyTypes.survey) {
      return t('assigned_surveyor')
    }
    else if (workorder.statuses?.status === "Unappointed" || workorder.statuses?.status === "Reported to EMA") {
      return t("assigned_contractor")
    }
    else if (workorder?.statuses?.status) {
      return t(workorder?.statuses?.status)
    }
    else {
      return "-"
    }
  }
  return (
    <>
      {!isLoading ? (
        <div className="w-full desk-view-only" data-testid="work-order">
          <div className="border border-grey bg-grey rounded-lg mb-4">
            <div className="bg-teal-dark px-4 py-2 rounded-t-lg">
              <div className="flex flex-row justify-between items-center">
                <h2 className="my-0 text-white flex flex-row justify-between items-center">
                  <img src={woImg} className="text-white text-2xl mr-6 sm:mr-4 bd-highlight logo logoLeft" alt="" />

                  {t("Work_Order_Type_CP041")} {workorder.job?.repairType
                    ? (workorder.job.repairType?.[0]?.toUpperCase() + workorder.job.repairType.slice(1))
                    : (workorder.job?.workProgramme !== null && workorder.job?.workProgramme !== "" && workorder.job?.workProgramme !== undefined)
                      ? t(workorder.job?.workProgramme)
                      : workorder.statuses?.isDraft ? t("draft") : workOrderType
                        ? workOrderType : null}

                </h2>
                {currentAssetEligibilityDetails?.isEligibleToRaiseARepair && (assetValue === "Property"
                  ? isActiveTenancy
                  : true) ? (
                  <div className="menu-nav ms-auto bd-highlight aa">
                    <div className="dropdown-container btn-group">
                      <div
                        className="three-dots text-white btn btn-sm show kebabMenu"
                        data-testid="dropFunction"
                        data-bs-toggle="dropdown"
                        onClick={dropDownFunction}
                      ></div>

                      <div
                        className="dropdown-ast px-2 dropdown-menu mt-45 show cc"
                        style={{ display: dropDown }}
                      >
                        <a
                          onClick={callPageHandler}
                          data-testid="callHandler"
                          className="text-black  text-base no-underline"
                        >
                          <div className={"cursor-pointer dropdown-item" + (isP360Maintainence ? 'text-opacity-25 pe-none' : '')}>
                            {(assetValue ===
                              "Property"
                              ? t("Create_repair")
                              : t("raise_comm"))}
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="px-4 py-2 grid grid-cols-1 md:grid-cols-12 gap-2 mt-3">
              {(hasAR1Role(getPermissionsData) && workorder.statuses?.isPendingAssessment && workorder?.assessmentInformation && workorder?.job?.sorCode === t("PRODAMP")) && <div
                data-testid="alert-warning"
                className="error mb-8"
                role="alert"
                placeholder="alert-message"
              >
                <div className="w-full px-2 py-2 bg-yellow flex justify-between">
                  <div className="flex items-center">
                    <div className="pl-4 pr-2">
                      <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
                    </div>
                    <div className="flex items-center">
                      <p
                        data-testid="locatioAlert"
                        className="w-full text-left my-2 font-AvantGardeGothic-Md"
                      >
                        {t("Damp_and_mould_assessment_required")}
                      </p>
                    </div>
                  </div>
                  <Button
                    id="btn_finish_repairfinal"
                    data-testid="Start_Assessment_button"
                    onClick={completeAssessment}
                    className="button-class rf-actions__viewRepair"
                    disabled={false}
                  >
                    {t("Start_Assessment")}
                  </Button>
                </div>
              </div>}
              <div className="px-4 py-2 grid grid-cols-1 md:grid-cols-3 gap-2 mt-3">
                <div className="mb-3">
                  <strong>{t("Date_Creation")}</strong>
                  <br></br>
                  {formatDateWithFromCalendar(workorder.raisedDate || "")}
                </div>

                <div className="mb-3 cardEmail" data-testid="assetType">
                  <strong>{t("property_type_txt")}</strong>

                  <br></br>
                  {formatContent(workorder.asset?.type?.assetTypeName)}
                </div>

                <div className="mb-3">
                  <strong>{t("Contractor_CP114")}</strong>

                  <br></br>
                  {getContractorDisplayName()}
                </div>

                <div className="mb-3" data-testid="createdBy">
                  <strong>{t("Created_By_CP115")}</strong>

                  <br></br>
                  {formatContent(getCreatedBy(workorder))}
                </div>

                {workorder.job?.repairType !== SurveyTypes.survey &&
                  (
                    <div className="mb-3">
                      <strong>{t("Location_CP105")}</strong>

                      <br></br>
                      {formatContent(workorder.job?.location?.location)}
                    </div>
                  )}

                <div className="mb-3">
                  <strong>{t("Contractor_phone_no")}</strong>

                  <br></br>
                  {contractorPhone && contractorPhone !== "" && !EmaUnknownContactTriage ? contractorPhone : "-"}
                </div>

                <div className="mb-3">
                  <strong>{t("Status_CP068")}</strong>
                  <br></br>
                  {StatusShow(workorder)}
                </div>

                <div className="mb-3" data-testid="PriorityValue">
                  <strong>{t("Priority_CP103")}</strong>

                  <br></br>
                  {formatContent(
                    retrievePriority(
                      workorder.statuses?.isEmergency,
                      workorder.statuses?.isOutOfHours,
                      workorder.statuses?.isRecall,
                      workorder?.job?.priority?.code
                    )
                  )}
                </div>

                <div className="mb-3 cardEmail" data-testid="ContractorEmail">
                  <strong>{t("Contractor_email")}</strong>

                  <br></br>
                  {contractorEmail && contractorEmail !== "" && !EmaUnknownContactTriage ? contractorEmail : "-"}
                </div>

                <div className="mb-3">
                  <strong>{t("Status_Change_Date_CP044")}</strong>

                  <br></br>
                  {formatDateWithFromCalendar(statusChangeDate)}
                </div>
                {showCancellationInfo() && (
                  <>
                    <div className="mb-3 cardEmail" data-testid="cancelledBy">
                      <strong>{t("Cancelled_By")}</strong>

                      <br></br>
                      {getCancelledBy()}
                    </div>
                    <div className="mb-3 cardEmail" data-testid="cancelledReason">
                      <strong>{t("Cancellation_Reason")}</strong>

                      <br></br>
                      {getCancelledReason()}
                    </div>
                  </>
                )}
                <div className="mb-3">
                  <strong>{t("Description_CP067")}</strong>

                  <br></br>
                  {<div>
                    {descriptionText}
                  </div>}
                </div>

                {workorder.job?.repairType === SurveyTypes.survey ? (
                  <div className="mb-3 cardEmail" data-testid="SurveyContractorEmail">
                    <strong>{t("Contact_Details")}</strong>

                    <br></br>
                    {getContactNumber()}
                  </div>
                ) : (
                  <div className="mb-3 cardEmail" data-testid="ContactEmail">
                    <strong>{t("Contact_Details")}</strong>

                    <br></br>
                    {getContactNumber()}
                  </div>
                )}



                {isEmaContractor &&
                  <div className="mb-3 cardEmail">
                    <strong>{t("EMA_numbers")}</strong>

                    <br></br>
                    {emaNumbers.length > 0 ? emaNumbers.join(", ") : "-"}
                  </div>
                }

                {isEmaContractor &&
                  <div className="mb-3 cardEmail">
                    <strong>{t("EMA_emails")}</strong>

                    <br></br>
                    {emaEmails.length > 0 ? emaEmails.join(", ") : "-"}
                  </div>
                }
              </div>
            </div>

            <div className={isMobile ? "mb-3 wod-relative bg-grey" : "errorAPIComp wod-relative bg-grey"}>
              {!isLoading && workorder?.identifiers && workOrderData?.identifiers && (
                <ErrorComponent input={[getWorkOrderByIdAPI, getWorkOrderEntity, getRepairHistories]} />
              )}
            </div>

            {(
              (workorder.job && workorder.job.description && workorder.job.description !== "") ||
              (workOrderData?.statuses?.isEnhancedDiagnosticsRepair && diagnosticsDetails)
            ) && (
                <div className="accordion-item" id={
                  "WorkOrderAdditionalInfo-main-div" +
                  workorder.identifiers?.worksOrderIdentifier
                }>
                  <div className="accordion-title" id={
                    "WorkOrderAdditionalInfo-main-accor1" +
                    workorder.identifiers?.worksOrderIdentifier
                  }>
                    <div
                      className="flex items-center w-full px-3 py-2 cursor-pointer bg-dl-teal"
                      data-testid="WorkOrderAdditionalInfo-more-details"
                      id={
                        "WorkOrderAdditionalInfo-det" +
                        workorder.identifiers?.worksOrderIdentifier
                      }
                      onClick={(event) =>
                        viewWorkOrderDescriptionHandler(
                          workorder.identifiers?.worksOrderIdentifier ?? "",
                          workorder?.job?.description ?? ""
                        )
                      }
                    >
                      <p
                        className="w-full text-left my-2 global-txt mt-2"
                        id={
                          "WorkOrderAdditionalInfo-p1" +
                          workorder.identifiers?.worksOrderIdentifier
                        }
                      >
                        <strong>{t("More_DetailsCP106")}</strong>
                      </p>
                      {viewActiveToggle(workorder.identifiers?.worksOrderIdentifier)}
                    </div>
                    {activeWorkOrder === workorder.identifiers?.worksOrderIdentifier && (
                      <>
                        {workorder?.statuses?.isEnhancedDiagnosticsRepair && diagnosticsDetails ? (
                          <RepairDiagnosticsDetailsCard diagnosticsDetails={diagnosticsDetails} additionalInformation={workorder.job?.additionalInformation ?? "-"} />
                        ) : (
                          additionalInfo && additionalInfo !== "" && viewWorkOrderDetail(additionalInfo)
                        )}

                      </>
                    )}
                  </div>
                </div>
              )}
          </div>
        </div>
      ) : (
        <div className="div-loader">
          <div className="SpinnerWrapper">
            <LoadingSpinner />
          </div>
        </div>
      )}
    </>
  );
};
export default WorkOrderDetailsComponent;